import React from "react";
import "./LoadingBox.scss";

export default function LoadingBox() {
  return (
    <div className="loading-box">
      <p className="loading-box__text">Loading...</p>
    </div>
  );
}
